import PageState from "./state"
import mutations from "./mutations"
import { getModule } from '@/store/store'
let u = navigator.userAgent;
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
let device= isAndroid?"H5_ANDROID":"H5_IOS"

let APIS = {
	//提取页面 金额信息
	withdrawInfo:`/apis/moyin-account/v1/txg/withdraw/info?device=${device}`,
	//提现项目列表信息
	withdrawList:`/apis/moyin-account/v1/txg/withdraw/list?device=${device}`,
	//获取最新使用银行卡信息
	getBankCardRecent:`/apis/moyin-account/v1/txg/bankCard/recent?device=${device}`,
	//分页面获取银行卡列表
	getBankCardList: `/apis/moyin-account/v1/txg/bankCard?device=${device}`,
	// 登录用户会员状态
	getVipInfo: `/apis/moyin-account/v1/vip/status`,
	//提现
	getCash: {
		custom: true,
		url: `/apis/moyin-account/v1/txg/withdraw/cashOutReq`,
		method: 'post',
		headers: {
			'content-type': 'application/json',
			'deviceOrigin': device
		}
	}
}
export default {
	...getModule({
		state: new PageState(),
		mutations,
		actions: {},
		APIS,
		name: "withDrawIndexPage"
	})
}